._1ucvhm0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
._1ucvhm1 {
  padding: 24px;
  background-color: var(--_1qu8za2d);
  display: flex;
  flex-direction: column;
  gap: 24px;
}
._1ucvhm1[data-empty] {
  background-color: var(--_1qu8za2b);
}
._1ucvhm2 {
  font-weight: 500;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
._1ucvhm3 {
  box-shadow: none;
  outline: none;
}
@media screen and (min-width: 768px) {

}
@media screen and (min-width: 1024px) {
  ._1ucvhm2 {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.3;
    letter-spacing: -0.02em;
  }
}